/*
 * Eleanor Leftwich navigation tracking (ELOPS-46)
 * Events: nav_click, nav_open, nav_back, nav_search -> GA4 property G-JVT4L515DK only.
 * Theme: Pipeline 8.0.0. Desktop = nav.header__menu, mobile drawer = #header-menu.
 * Values come from data attributes when present (data-nav-label, data-nav-parent,
 * data-nav-category, data-nav-position) and fall back to the rendered markup.
 */
(function () {
  'use strict';
  if (window.__elNavTracking) return;
  window.__elNavTracking = true;

  var MEASUREMENT_ID = 'G-JVT4L515DK';
  var NAV_VERSION = 'current';
  var OPEN_DELAY_MS = 500;
  var DEBUG = /[?&]nav_debug=1/.test(location.search);

  // DRAFT category map for nav_category. Merchandising must sign off before launch.
  var CATEGORY_MAP = {
    '/collections/new': 'new', '/collections/fall-2026': 'fall_26', '/collections/summer-2026': 'summer_26',
    '/collections/spring-2026': 'spring_26', '/collections/pre-spring-2026': 'pre_spring_26',
    '/collections/sea-island-cotton': 'sea_island_cotton', '/collections/ready-to-ship': 'ready_to_ship',
    '/collections/sale': 'sale', '/collections/shop-all': 'shop_all', '/collections': 'clothing',
    '/collections/collection-list': 'collections', '/collections/collaborations': 'collaborations',
    '/collections/elc-x-macian': 'collab_macian', '/collections/el-x-drawbertson': 'collab_drawbertson',
    '/collections/jennifer-klein-couture': 'collab_jennifer_klein', '/collections/thrift-tell': 'collab_thrift_tell',
    '/collections/knits': 'knits', '/collections/sea-island-cotton-knits': 'knits_sea_island',
    '/collections/mulberry-silks': 'knits_silk', '/collections/cotton': 'cotton', '/collections/cashmere-1': 'cashmere',
    '/collections/cashmere-silk-knits': 'cashmere', '/collections/spring-knits': 'knits_spring',
    '/collections/tissue-knits': 'knits_tissue', '/collections/core': 'core', '/collections/core-dresses': 'dresses',
    '/collections/core-shirts': 'shirts', '/collections/core-knits': 'knits', '/collections/outerwear': 'outerwear',
    '/collections/dresses': 'dresses', '/collections/tops': 'tops', '/collections/bottoms': 'bottoms',
    '/collections/shorts': 'shorts', '/collections/warm-weather-sets': 'sets', '/collections/accessories': 'accessories',
    '/collections/shop-all-conservatory': 'conservatory', '/collections/no-i-hand-crochet-capsule': 'conservatory',
    '/collections/volume-ii-filigree-jewelry': 'conservatory', '/blogs/meet-our-materials': 'materials'
  };

  function send(name, params) {
    var p = { send_to: MEASUREMENT_ID, transport_type: 'beacon' };
    for (var k in params) { if (params[k] !== undefined && params[k] !== null) p[k] = params[k]; }
    var fn = window.gtag || function () { (window.dataLayer = window.dataLayer || []).push(arguments); };
    fn('event', name, p);
    if (DEBUG && window.console) console.log('[nav-tracking]', name, p);
  }

  function clean(s) { return (s || '').replace(/\s+/g, ' ').trim(); }

  function titleCase(s) {
    if (!s || s !== s.toUpperCase()) return s;
    return s.toLowerCase().replace(/\b[a-z]/g, function (m) { return m.toUpperCase(); })
      .replace(/\b(Ii|Iii|Iv|Vi)\b/g, function (m) { return m.toUpperCase(); });
  }

  function pathOf(href) {
    try { return new URL(href, location.origin).pathname; } catch (e) { return ''; }
  }

  function categoryFor(el, path) {
    var attr = el && el.getAttribute('data-nav-category');
    if (attr) return attr;
    if (CATEGORY_MAP[path]) return CATEGORY_MAP[path];
    if (/^\/pages\/.*lookbook|^\/apps\/load\/.*lookbook/.test(path)) return 'lookbook';
    return 'uncategorized';
  }

  function isTile(a) {
    return a.classList.contains('link-over-image') || a.classList.contains('text-btn-arrow-right');
  }

  function labelOf(a) {
    var attr = a.getAttribute('data-nav-label');
    if (attr) return attr;
    var t = clean(a.textContent);
    if (!t && isTile(a)) {
      var scope = a.closest('.header__dropdown, .sliderule__panel, .mobile__menu__dropdown') || document;
      var caption = scope.querySelector('a.text-btn-arrow-right[href="' + a.getAttribute('href') + '"]');
      t = caption ? clean(caption.textContent) : '';
    }
    if (!t) t = clean(a.getAttribute('aria-label'));
    return titleCase(t);
  }

  function desktopTopLabel(el) {
    var item = el.closest('.menu__item');
    var top = item && item.querySelector('a.navlink--toplevel');
    return top ? labelOf(top) : '';
  }

  function panelLabel(opener) {
    var attr = opener.getAttribute('data-nav-label');
    if (attr) return attr;
    return titleCase(clean(opener.textContent).replace(/\s*Expand menu\s*$/i, ''));
  }

  function drawerRootOpener(panel) {
    var drawer = document.getElementById('header-menu');
    var opener = null;
    while (panel) {
      opener = drawer.querySelector('[data-sliderule-open="' + panel.id + '"]');
      var up = opener && opener.parentElement && opener.parentElement.closest('[id^="sliderule-"]');
      if (!up) break;
      panel = up;
    }
    return opener;
  }

  function desktopPosition(a) {
    var attr = a.getAttribute('data-nav-position');
    if (attr) return parseInt(attr, 10);
    if (isTile(a)) {
      var scope = a.closest('.header__dropdown');
      var imgs = scope ? [].slice.call(scope.querySelectorAll('a.link-over-image')) : [];
      var self = a.classList.contains('link-over-image') ? a : (scope && scope.querySelector('a.link-over-image[href="' + a.getAttribute('href') + '"]'));
      return imgs.indexOf(self) + 1 || undefined;
    }
    if (a.classList.contains('navlink--toplevel')) {
      var tops = [].slice.call(document.querySelectorAll('nav.header__menu a.navlink--toplevel'));
      return tops.indexOf(a) + 1;
    }
    var dd = a.closest('.header__dropdown');
    var list = dd ? [].slice.call(dd.querySelectorAll('a.navlink')) : [];
    return list.indexOf(a) + 1;
  }

  function drawerPosition(a, panel) {
    var attr = a.getAttribute('data-nav-position');
    if (attr) return parseInt(attr, 10);
    var root = panel;
    var drawer = document.getElementById('header-menu');
    while (root) {
      var op = drawer.querySelector('[data-sliderule-open="' + root.id + '"]');
      var up = op && op.parentElement && op.parentElement.closest('[id^="sliderule-"]');
      if (!up) break;
      root = up;
    }
    if (isTile(a)) {
      var tiles = [].slice.call(root.querySelectorAll('a.link-over-image'));
      var self = a.classList.contains('link-over-image') ? a : root.querySelector('a.link-over-image[href="' + a.getAttribute('href') + '"]');
      return tiles.indexOf(self) + 1 || undefined;
    }
    var items = [].slice.call(root.querySelectorAll('a.sliderow__title, button.sliderow[data-sliderule-open]'))
      .filter(function (el) { return !isOverview(el); });
    return items.indexOf(a) + 1;
  }

  // First link in each drawer panel is the section's own page (for example "Clothing" in the Clothing panel).
  function isOverview(el) {
    var p = el.closest && el.closest('[id^="sliderule-"]');
    return !!p && el.tagName === 'A' && p.querySelector('a.sliderow__title') === el;
  }

  function drawerTopPosition(rootOpener) {
    var items = [].slice.call(document.querySelectorAll('#header-menu button.sliderow[data-sliderule-open]'))
      .filter(function (b) { return !b.parentElement.closest('[id^="sliderule-"]'); });
    return items.indexOf(rootOpener) + 1;
  }

  function linkParams(a) {
    var inDrawer = !!a.closest('#header-menu');
    var path = pathOf(a.getAttribute('href'));
    var params = {
      nav_label: labelOf(a),
      nav_url: path,
      nav_element: isTile(a) ? 'tile' : 'link',
      nav_menu_type: inDrawer ? 'mobile_drawer' : 'desktop_mega',
      nav_version: NAV_VERSION,
      nav_category: categoryFor(a, path)
    };
    if (inDrawer) {
      var panel = a.closest('[id^="sliderule-"]');
      var rootOpener = panel ? drawerRootOpener(panel) : null;
      if (isOverview(a)) {
        var ownOpener = document.querySelector('#header-menu [data-sliderule-open="' + panel.id + '"]');
        var isRoot = ownOpener === rootOpener;
        params.nav_level = isRoot ? 'top' : 'sub';
        params.nav_parent = isRoot ? '' : (rootOpener ? panelLabel(rootOpener) : '');
        params.nav_position = isRoot ? drawerTopPosition(ownOpener) : drawerPosition(ownOpener, ownOpener.closest('[id^="sliderule-"]'));
      } else {
        params.nav_level = 'sub';
        params.nav_parent = a.getAttribute('data-nav-parent') || (rootOpener ? panelLabel(rootOpener) : '');
        params.nav_position = drawerPosition(a, panel);
      }
    } else {
      var top = a.classList.contains('navlink--toplevel');
      params.nav_level = top ? 'top' : 'sub';
      params.nav_parent = top ? '' : (a.getAttribute('data-nav-parent') || desktopTopLabel(a));
      params.nav_position = desktopPosition(a);
    }
    return params;
  }

  function trackable(a) {
    if (!a || !a.getAttribute('href')) return false;
    if (a.classList.contains('drawer__account') || a.classList.contains('navlink--cart')) return false;
    if (a.hasAttribute('data-popdown-toggle') || a.hasAttribute('data-drawer-toggle')) return false;
    return a.classList.contains('navlink') || a.classList.contains('sliderow__title') || isTile(a);
  }

  // nav_click
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || !(a.closest('nav.header__menu') || a.closest('#header-menu'))) return;
    if (!trackable(a)) return;
    send('nav_click', linkParams(a));
  }, true);

  // nav_open: desktop dropdown after 500 ms, once per opening
  var openTimers = new WeakMap();
  var opened = new WeakSet();
  function desktopOpenParams(item) {
    var top = item.querySelector('a.navlink--toplevel');
    var path = top ? pathOf(top.getAttribute('href')) : '';
    return {
      nav_open_type: 'dropdown', nav_label: top ? labelOf(top) : '', nav_level: 'top', nav_parent: '',
      nav_url: path, nav_position: top ? desktopPosition(top) : undefined, nav_menu_type: 'desktop_mega',
      nav_version: NAV_VERSION, nav_category: categoryFor(top, path)
    };
  }
  document.addEventListener('mouseover', function (e) {
    var item = e.target.closest && e.target.closest('nav.header__menu .menu__item');
    if (!item || !item.querySelector('.header__dropdown')) return;
    if (item.contains(e.relatedTarget) || openTimers.has(item) || opened.has(item)) return;
    openTimers.set(item, setTimeout(function () {
      openTimers.delete(item);
      opened.add(item);
      send('nav_open', desktopOpenParams(item));
    }, OPEN_DELAY_MS));
  });
  document.addEventListener('mouseout', function (e) {
    var item = e.target.closest && e.target.closest('nav.header__menu .menu__item');
    if (!item || item.contains(e.relatedTarget)) return;
    if (openTimers.has(item)) { clearTimeout(openTimers.get(item)); openTimers.delete(item); }
    opened.delete(item);
  });

  // nav_open (drawer, panel) and nav_back
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;
    var burger = t.closest('button[data-drawer-toggle="hamburger"]');
    if (burger && !burger.classList.contains('drawer__close') && burger.getAttribute('aria-expanded') !== 'true') {
      send('nav_open', { nav_open_type: 'drawer', nav_label: 'Menu', nav_level: 'top', nav_menu_type: 'mobile_drawer', nav_version: NAV_VERSION });
      return;
    }
    var opener = t.closest('button[data-sliderule-open]');
    if (opener) {
      var parentPanel = opener.parentElement && opener.parentElement.closest('[id^="sliderule-"]');
      var rootOpener = parentPanel ? drawerRootOpener(parentPanel) : null;
      var label = panelLabel(opener);
      var topLabel = rootOpener ? panelLabel(rootOpener) : label;
      var probe = (rootOpener || opener);
      var items = [].slice.call(document.querySelectorAll('#header-menu button.sliderow[data-sliderule-open]')).filter(function (b) { return !b.parentElement.closest('[id^="sliderule-"]'); });
      send('nav_open', {
        nav_open_type: 'panel', nav_label: label, nav_level: rootOpener ? 'sub' : 'top', nav_parent: rootOpener ? topLabel : '',
        nav_position: (rootOpener ? drawerPosition(opener, parentPanel) : items.indexOf(opener) + 1) || undefined,
        nav_menu_type: 'mobile_drawer', nav_version: NAV_VERSION,
        nav_category: (probe.getAttribute('data-nav-category')) || undefined
      });
      return;
    }
    var back = t.closest('button[data-sliderule-close]');
    if (back) {
      var id = back.getAttribute('data-sliderule-close');
      var op = document.querySelector('#header-menu [data-sliderule-open="' + id + '"]');
      var pp = op && op.parentElement && op.parentElement.closest('[id^="sliderule-"]');
      var ro = pp ? drawerRootOpener(pp) : null;
      send('nav_back', {
        nav_label: op ? panelLabel(op) : '', nav_level: ro ? 'sub' : 'top', nav_parent: ro ? panelLabel(ro) : '',
        nav_menu_type: 'mobile_drawer', nav_version: NAV_VERSION
      });
    }
  }, true);

  // nav_search
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action="/search"]')) return;
    var input = f.querySelector('input[name="q"]');
    var term = clean(input && input.value).toLowerCase();
    if (!term) return;
    send('nav_search', {
      search_term: term, nav_menu_type: f.closest('#header-menu') ? 'mobile_drawer' : 'desktop_mega', nav_version: NAV_VERSION
    });
  }, true);
})();
